import * as Yup from 'yup'

export type ForgotPasswordFormValues = {
  email: string
}

export const forgotPasswordInitialValues: ForgotPasswordFormValues = {
  email: '',
}

export const forgotPasswordValidationSchema = Yup.object().shape({
  email: Yup.string()
    .required('Please enter email address')
    .email('Please enter a valid email'),
})
